import { render } from "./Trans.vue?vue&type=template&id=1867ba3e&scoped=true"
import script from "./Trans.vue?vue&type=script&lang=js"
export * from "./Trans.vue?vue&type=script&lang=js"

import "./Trans.vue?vue&type=style&index=0&id=1867ba3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1867ba3e"]])

export default __exports__